import { defaultInputProps } from '../../../FormContainer/defaultFormStates';
import {
  affiliateID,
  siteOptions,
  quoteWizardContracts
} from '../../../common/commonRequests';
import ValidateContracts from './validation';
import ContractDropdown from './ContractDropdown/ContractDropdown';

export const editContractState = (editMode) => ({
  site: {
    ...defaultInputProps,
    name: 'site',
    type: 'select',
    label: 'Vertical',
    options: () =>
      siteOptions(false, false, false, [], {
        value: 'none',
        display: 'Choose a Vertical',
        disabled: true
      }),
    value: 'none',
    defaultVal: 'none',
    validate: ValidateContracts.site,
    hidden: editMode
  },
  affiliateID: {
    ...defaultInputProps,
    name: 'affiliateID',
    type: 'autocomplete',
    label: 'Affiliate ID',
    options: () => affiliateID(),
    value: '',
    defaultVal: 'All Affiliates',
    validate: ValidateContracts.affiliate,
    hidden: editMode
  },
  contract: {
    ...defaultInputProps,
    name: 'contract',
    label: 'QuoteWizard Contract',
    type: 'custom',
    Component: ContractDropdown,
    value: {
      contract_id: '',
      contract_name: ''
    },
    dependencyName: 'site',
    dependency: 'site',
    options: (dependency) => quoteWizardContracts(dependency),
    validate: ValidateContracts.contract
  }
});
